import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll an element into view when the address names it: `/settings#luts`.
 *
 * ── WHY THIS IS NEEDED AT ALL ──
 * A browser scrolls to a fragment on a full page load. A client-side
 * navigation is not one - React Router changes the address and renders, and
 * nothing scrolls - so a review finding's "Record the LUT" landed at the top
 * of Settings with the card it named twenty screens down.
 *
 * `ready` waits for whatever the target is drawn from: a card still showing
 * its skeleton has no height to scroll to, and scrolling to it then lands
 * short once the content arrives.
 */
export function useScrollToHash(id: string, ready = true): void {
  const { hash } = useLocation();
  useEffect(() => {
    if (!ready || hash !== `#${id}`) return;
    document.getElementById(id)?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }, [hash, id, ready]);
}
